// extracted by mini-css-extract-plugin
export var $animation_name = "Menu-module--$animation_name--ac616";
export var Menu = "Menu-module--Menu--dfd32";
export var Menu___isOpen = "Menu-module--Menu___isOpen--bf29c";